var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DxForm',{attrs:{"id":"ActivityForm-form","col-count":2}},[_c('DxSimpleItem',{attrs:{"name":"code","data-field":_vm.$t('Activity.code'),"editor-options":{
      value: _vm.currentActivity.code,
      onValueChanged: _vm.onValueChanged,
    }}},[_c('DxRequiredRule',{attrs:{"message":_vm.$t('Activity.code_validation')}})],1),_vm._v(" "),_c('DxSimpleItem',{attrs:{"name":"name","data-field":_vm.$t('Activity.name'),"editor-options":{
      value: _vm.currentActivity.name,
      onValueChanged: _vm.onValueChanged,
    }}},[_c('DxRequiredRule',{attrs:{"message":_vm.$t('Activity.name_validation')}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }